export default __webpack_public_path__ + "static/media/diamant.bc00d384.jpg";